import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState
} from "react";
import SelectEstablishment from "../../../../components/MyCustom/SelectEstablishment";
import SelectStore from "../../../../components/MyCustom/SelectStore";
import TableCustom from "../../../../components/MyCustom/TableCustom";
import Breadcrumb from "../../../../components/bootstrap/Breadcrumb";
import Button from "../../../../components/bootstrap/Button";
import Card, { CardBody } from "../../../../components/bootstrap/Card";
import ModalSaidaInsumo from "../../../../components/modals/insumoLoja/ModalSaidaInsumo";
import { DefaultContext } from "../../../../contexts/default";
import InsumosDB from "../../../../database/wrappers/insumos";
import InsumosExitDB from "../../../../database/wrappers/insumosExit";
import useDarkMode from "../../../../hooks/useDarkMode";
import Page from "../../../../layout/Page/Page";
import PageWrapper from "../../../../layout/PageWrapper/PageWrapper";
import SubHeader, {
    SubHeaderLeft,
    SubHeaderRight,
} from "../../../../layout/SubHeader/SubHeader";
import { demoPages } from "../../../../menu";
import dateFormat from "dateformat";
import ModalHistoricoInsumo from "../../../../components/modals/insumoLoja/ModalHistoricoInsumo";
import { orderBy } from "firebase/firestore";

const SaidaInsumo = ({ dataFilter }) => {
    const { darkModeStatus } = useDarkMode();

    const { estabSelected, storeSelected, onShowAlert } = useContext(DefaultContext);
    const [openExitModal, setopenExitModal] = useState(false)
    const [openHistoryModal, setOpenHistoryModal] = useState(false);
    const [historySelected, setHistorySelected] = useState(null);
    const [insumesExitHistory, setInsumesExistHistory] = useState([])
    const [insumes, setInsumes] = useState([])

    const [renderList, setRenderList] = useState([])

    const handleOpeModal = useCallback(() => {
        setopenExitModal(true)
    })

    const handleCloseModal = useCallback(() => {
        setopenExitModal(false)
    })

    const openModal = useCallback((row) => {
        setHistorySelected(row);
        setOpenHistoryModal(true);
    }, [])

    useEffect(() => {
        if (!estabSelected || !storeSelected) return;

        const onInsumesHistory = new InsumosExitDB(estabSelected, storeSelected).on(
            setInsumesExistHistory,
            orderBy('generated_at', 'desc'),
        )

        const onInsumes = new InsumosDB(estabSelected).on(
            setInsumes
        )

        return () => {
            onInsumesHistory();
            onInsumes();
        }
    }, [estabSelected, storeSelected])

    useEffect(() => {
        const toRenderList = insumesExitHistory
            .map(history => {

                return {
                    id: history.id,
                    name: history.operator,
                    insumes: history.insumes,
                    created_at: history.created_at,
                    generated_at: history.generated_at
                }

            })
            .filter(Boolean)

        setRenderList(toRenderList)

    }, [insumesExitHistory, insumes])

    const columns = useMemo(
        () => [
            {
                label: "Id",
                field: "id",
                hidden: true,
                noExport: true
            },
            {
                label: 'Lançamento',
                field: 'generated_at',
                format: row => dateFormat(row.generated_at?.toDate(), 'dd/mm/yyyy HH:MM'),
                isDate: true
            },
            {
                label: "Operador",
                field: "name",
            },
            {
                label: '#',
                field: '{row}',
                format: row => {
                    return (<Button
                        color="dark" icon="eye"
                        onClick={() => openModal(row)}
                    />)
                },
                noExport: true,
            },
        ],
        [openModal]
    );

    return (
        <>
            <PageWrapper title={demoPages.pdvLoja.subMenu.saidaInsumos.text}>
                <SubHeader>
                    <SubHeaderLeft>
                        <Breadcrumb
                            list={[
                                { title: "PDV Loja", to: "/pdvLoja" },
                                { title: "Lançamento de insumos", to: "/pdvLoja/Lançamento de insumos" },
                            ]}
                        />
                    </SubHeaderLeft>

                    <SubHeaderRight>
                        <Button
                            color='primary'
                            icon='plus'
                            shadow="sm"
                            hoverShadow="sm"
                            onClick={handleOpeModal}
                        >
                            Cadastrar
                        </Button>
                    </SubHeaderRight>

                </SubHeader>

                <Page container="fluid">
                    <Card>
                        <CardBody className="table-responsive p-5">
                            <div className="row d-flex align-items-center mx-1">
                                <SelectEstablishment />
                                <SelectStore />
                            </div>
                            <TableCustom
                                columns={columns}
                                rows={renderList}
                                fileName="Saida-insumos"
                            />
                        </CardBody>
                    </Card>
                </Page>
            </PageWrapper>


            <ModalHistoricoInsumo
                open={openHistoryModal}
                handleOpen={() => {
                    setOpenHistoryModal(false)
                    setHistorySelected(null);
                }}
                rowSelected={historySelected}
            />
            <ModalSaidaInsumo
                open={openExitModal}
                handleOpen={handleCloseModal}
            />

        </>
    );
};

export default SaidaInsumo;
